/*
 * @Author: your name
 * @Date: 2021-11-09 09:11:34
 * @LastEditTime: 2021-11-09 09:25:04
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/router/japan.js
 */
// 日语
const japanIndex = () => import('../pages/japan/japanIndex.vue');
export default [
  {
    path: '/japanIndex',
    component: japanIndex,
  },
];
